/**
 * 取获顶级菜单点击时重定向router的path
 * @param menu
 * @returns {*}
 */

import { APP_SEC_LEVEL, APP_TRD_LEVEL, APP_BASE_ROUTE } from '../config'
import routers from '@/router/routes'
import { parse } from 'qs'

/**
 * 获取进入系统后默认的顶级菜单名称
 * @returns {string|*}
 */
export const getAppDefaultMenu = () => {
  const { redirect } = getPageQuery()
  // console.log(redirect)
  // const pathname = window.location.pathname
  const pathname = redirect || window.location.pathname
  const routes = removeHideInMenuRouters()
  const top = routes.find(it => pathname.startsWith(it.path)) || null
  return !top ? APP_BASE_ROUTE : top?.name
}

/**
 * 根菜单跳转
 * @param menu
 * @returns {*}
 */
export const rootMenuDirect = menu => {
  const secondMenu = menu.children[APP_SEC_LEVEL]
  if (secondMenu.path !== '') {
    return secondMenu.path
  } else {
    const trdMenu = secondMenu.children[APP_TRD_LEVEL]
    return trdMenu.path
  }
}

/**
 * 递归排除隐藏的菜单
 * @param menuList
 * @returns {[]}
 */
export const matchMenu = menuList => {
  const result = []
  menuList.forEach(it => {
    const { meta: { isHideInMenu }, children } = it
    if (!isHideInMenu) {
      const matchChildren = (children && children.length !== 0) ? matchMenu(children) : null
      result.push({
        ...it,
        children: matchChildren
      })
    }
  })
  return result
}
/**
 * 后端只需要返回包含如下的格式
 * {
 *   path: '/xxx'
 *   name: 'xxx',
 *   children: {
 *     path: '/xxx/xxx,
 *     name: 'xxx',
 *   }
 * }
 * name或path任意为唯一值即可匹配（当然也可以自定id来匹配）
 * 如果有需要可以完全改为后端控制
 * @param frontMenuList 前端route数组
 * @param backMenuList 后端返回的route数组
 * @returns {*[]}
 */
export const getMenuList = (frontMenuList, backMenuList) => {
  // 先排除isHideInMenu
  const matchChildren = matchMenu(frontMenuList)
  if (!backMenuList || backMenuList.length === 0) {
    return matchChildren
  }
  const menuList = []
  const frontLen = matchChildren.length
  let i
  for (i = 0; i < frontLen; i++) {
    const item = matchChildren[i]
    const { path, name } = item
    const backItem = backMenuList.find(it => it.name === name || it.path === path)
    if (!backItem) {
      continue
    } else {
      const { children: defaultChildren } = item
      const children = defaultChildren.length !== 0 ? getMenuList(defaultChildren) : []
      menuList.push({
        ...item,
        ...backItem,
        children
      })
    }
  }
  return menuList
}

export const getBreadcrumbList = (currentPath, menuList) => {
  if (menuList.length === 0) return []
  const pathArray = currentPath.split('/').filter(it => it)
  const nameList = compressRouterName(pathArray, menuList)
  return nameList
}

/**
 * 返回route的name数组
 * @param pathArray[] eg: ["Home", "Dashboard", "Monitor"]
 * @returns {[]}
 */
export const compressRouterName = (pathArray, menuList) => {
  let res = []
  const list = []
  const len = pathArray.length
  let i
  for (i = 0; i < len; i++) {
    const endItem = list[list.length - 1] || null
    const currentName = pathArray[i]
    if (!endItem) {
      list.push(`/${currentName}`)
    } else {
      list.push(`${endItem}/${currentName}`)
    }
  }
  const firstBreadcrumb = menuList.find(it => it.path === list[0])
  const second = firstBreadcrumb.children.find(it => it.path === list[1])
  const trd = second.children.find(it => it.path === list[2])
  res = [firstBreadcrumb, second, trd]
  return res
}

/**
 * 去掉隐藏的菜单以及root菜单 - 简单的处理顶级菜单
 * 主要作用于顶部菜单的处理
 * @returns {*}
 */
export const removeHideInMenuRouters = () => {
  return routers.filter(it => !it.meta.isHideInMenu && it.name !== 'root')
}

/**
 * 获取顶部被选中的菜单的下标
 * 主要用于顶部菜单处理
 * @param currentRoute
 * @returns {*}
 */
export const getTopMenuIndex = (currentRoute) => {
  const routes = removeHideInMenuRouters()
  const { name } = currentRoute
  const menuIndex = routes.findIndex(it => it.name === name)
  return menuIndex
}

export const isPromise = obj => Boolean(obj) && typeof obj.then === 'function'

export const getPageQuery = () => parse(window.location.href.split('?')[1])
